import React, { Component } from "react";

import { Form, Button, Input, Card, message } from "antd";

import api from '../../../../services/api'

const { TextArea } = Input;

class Formulario extends React.Component {

    token = ''

    componentDidMount = async () => {
        const res_token_pipedrive = await api.get('/tokens/')
        this.token = res_token_pipedrive.data.pipedrive
    }

    handleBlurPasta = async e => {
        console.log(e)
    }

    buscarPasta = async (e) => {
        e.preventDefault()
        const { form } = this.props
        const { pasta } = form.getFieldsValue()
        try {
            let res = await api.get(`https://api.pipedrive.com/v1/deals/find?term=${pasta}&api_token=${this.token}`)
            //console.log(res.data.data)
            if (res.data.data == null || res.data.data.length != 1) {
                console.log('erro')
            } else {
                console.log(res.data.data[0])
            }
            //console.log(res)
        } catch (err) {
            console.log(err)
        }

    }

    render() {
        const { getFieldDecorator } = this.props.form
        return (
            <React.Fragment>
                <br />
                <Card title="Envio de SMS">
                    <Form layout="horizontal" onSubmit={this.buscarPasta}>
                        <Form.Item label="Pasta">
                            {getFieldDecorator('pasta', {
                                rules: [{ required: true, message: "Digite a pasta" }]
                            })(
                                <Input type="text" />
                            )}
                        </Form.Item>
                        <Button htmlType="submit" type="primary">Buscar</Button>
                    </Form>
                </Card>
            </React.Fragment>
        )
    }
}

export const EnvioForm = Form.create({ name: 'envio_form' })(Formulario);




// WEBPACK FOOTER //
// ./src/pages/Sms/Envio/components/envio_form.js